import {Alert} from 'platform/components';
import {VStack} from 'platform/foundation';

import type {CheckoutProfileError} from '@dms/api/sales';

export function CheckoutRuleFeedback(props: {errors: CheckoutProfileError[]}) {
  const errors = [
    ...new Map(
      props.errors.map((error) => [JSON.stringify([error.path, error.code, error.message]), error])
    ).values(),
  ];

  if (errors.length === 0) {
    return null;
  }

  return (
    <VStack spacing={2}>
      {errors.map((error) => (
        <Alert
          key={JSON.stringify([error.path, error.code, error.message])}
          type="banner"
          variant="error"
          title={error.message}
          message={error.rules?.map((rule) => rule.name).join(', ')}
        />
      ))}
    </VStack>
  );
}
